// extracted by mini-css-extract-plugin
export default {"SlideStopOverlay":"ButtonReplay_SlideStopOverlay__qW0Er","replayBtn":"ButtonReplay_replayBtn__HxHz7","replayText":"ButtonReplay_replayText__Cr82O"};